import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AlumniNavigation from '../Inc/AlumniNavigation';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Checkbox, Dropdown, Row, Modal, Popconfirm, Button, Col, Empty, Divider, Menu, Icon, Spin, Tooltip } from 'antd';
import { compose } from 'recompose';
import Skeleton from 'react-loading-skeleton';
import './style.css';
import Iframe from '../HOC/iframe';
import { history } from '../../container/History'
import Truncate from 'react-truncate';
import moment from 'moment'
import { DownOutlined } from '@ant-design/icons';
import MyCommunicationPreference from '../Inc/MyCommunicationPreference'
import NESAFooter from '../Inc/NESAFooter';
import MyAwardsComponent from '../Inc/AwardSections';
import SocialInfo from '../MyProfile/SocialInfo';
import HobbiesAndBusinessComponent from '../Inc/HobbiesAndBusiness';

import GetRanksDate from "../Inc/GetRanksDate";

const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

const currentDate = new Date();
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const menu = (
  <Menu className='memberships-dropdown' onClick={handleMenuClick}>
    <Menu.Item key="1">NESA Membership</Menu.Item>
    {/* <Menu.Item key="2">SAF Membership</Menu.Item> */}
  </Menu>
);

function handleMenuClick(e) {
  if (e.key == "1") {
    history.push('/purchase-membership')
  }
  if (e.key == "2") {
    history.push('saf-support')
  }
}

class AlumniDashboard extends Component {

  constructor(props) {
    super(props)
    this.publications = this.publications.bind(this)
    this.state = {
      // ...props,
      panelView : '',
      hasCurrentNESAmembership: false,
      ActiveMembership: undefined
    }
  }

  componentDidMount = () => {
    let getPanelView = localStorage.getItem("panelView") ?  JSON.parse(localStorage.getItem("panelView")) : "alumniTabView"
    this.setState({
      panelView: getPanelView
    })
    let loggedinUser = JSON.parse(localStorage.getItem('user'))
    let personGUID = loggedinUser.personGuid;
    let memberid = loggedinUser.membership.memberId
    let userid = loggedinUser.account.userId
    this.props.actions.getProfileInfo(personGUID)
    // this.props.actions.loadpublications()
    this.props.actions.getevents()
    this.props.actions.getEagleInfo()
    this.props.actions.getNESARegistrations(personGUID)
    this.props.actions.getSAFRegistrations(personGUID)
    this.props.actions.getAwards(personGUID, 'self')
    this.props.actions.getNESAmembershiplevels()
    this.props.actions.getSAFmembershiplevels()
    this.props.actions.getallcouncils()
    this.props.actions.getallscoutingassociations()
    this.props.actions.getStates()
    this.props.actions.getAllAffinityGroups()
    this.props.actions.getAllLocalAwards()
    this.props.actions.getAlumniInfo(personGUID, 'alumni')
  }
  
  componentWillReceiveProps = (nextprops) => {
    if (this.props.nesa_reg != nextprops.nesa_reg) {
      if (nextprops.nesa_reg && nextprops.nesa_reg.length !== 0) {
        let ActiveMembership = [];
        let currentMembership =  nextprops.nesa_reg.some(Item => {
            if(moment(currentDate).isSameOrBefore(Item.expireDate) && moment(currentDate).isSameOrAfter(Item.effectiveDate) || Item.expireDate == null){
              ActiveMembership.push(Item)
            return true
           }
        })
        this.setState({ hasCurrentNESAmembership : currentMembership ? true : false, ActiveMembership})
      }
      else{
        this.setState({ hasCurrentNESAmembership : false})
      }
    }
  }

  rendereagleflag = () => {
    if (this.props.eagleinfo) {
      if (Object.keys(this.props.eagleinfo).length != 0) {
        if (this.props.eagleinfo.eagleBoardReviewDate != "") {
          return <img className="dashboard-eagle-logo" src='./eagle-scout.png' />
        }
      }
    }
  }

  loadiFramscript = () => {
    const script = document.createElement("script");
    script.src = "//e.issuu.com/embed.js";
    script.async = true;
    document.body.appendChild(script);

  }

  address = () => {
    const addresses = (this.props.alumniprofileinfo && this.props.alumniprofileinfo.addresses) || [];
    
    if (!this.props.alumniprofileinfo || this.props.loading) {
      return <Skeleton width={200} />
    } else if(Array.isArray(addresses) && addresses.length != 0) {
      let getAddress;
      let personaddress = addresses.filter((data) => (typeof data.isPrimary === "string" && data.isPrimary.toLowerCase() === "true") || (typeof data.isPrimary === "boolean" && data.isPrimary))[0];
      if (personaddress){
        if (personaddress.countryId && personaddress.countryId === 616 ) {
          let city = personaddress.city ? personaddress.city : personaddress.primaryCity ? personaddress.primaryCity : '' 

          let state = personaddress.state ? personaddress.state : personaddress.primaryState ? personaddress.primaryState : '' 
          getAddress = `${city}${state.length ? `, ${state}` : '' }`;
        } else{
          getAddress = personaddress.address3 ? personaddress.address3 : 
          personaddress.addressLine3 ? personaddress.addressLine3 : ''
        }
        return (<span> <i className="fa fa-map-marker"></i> {getAddress} </span> );
      }
      return (<span> <i class='fa fa-map-marker'></i> N/A </span>)
    } else{
      return (<span> <i class='fa fa-map-marker'></i> {addresses} </span>)
    }
  }

  email = () => {
    if (!this.props.alumniprofileinfo) {
      return <Skeleton width={200} />
    } else if(Array.isArray(this.props.alumniprofileinfo.emails) && this.props.alumniprofileinfo.emails.length != 0){
      let personemail = this.props.alumniprofileinfo.emails.filter(data => (typeof(data.isPrimary) === "string" && data.isPrimary.toLowerCase() === "true" || typeof(data.isPrimary) === "boolean" && data.isPrimary))[0]
      if (personemail) {
        return (<span> <i class='fa fa-envelope'></i> {personemail.email} </span>)
      }
      return (<span> <i class='fa fa-envelope'></i> N/A </span>) // <Skeleton width={200} />
    } 
    else{
      return (<span> <i class='fa fa-envelope'></i> {this.props.alumniprofileinfo.emails} </span>)
    }
  }

  currentCouncil = () => {
    if (!this.props.profileinfo) {
      return <Skeleton width={200} />
    } else {
      let currentCouncilGuid = this.props.profileinfo.profile && this.props.profileinfo.profile.ownerCouncilOrgGuid ? this.props.profileinfo.profile.ownerCouncilOrgGuid : '';
      let councilDetails = {};
      if(this.props.councils) {
        let allCouncils = this.props.councils;
        allCouncils.map(council => {
          if(council.organizationGuid == currentCouncilGuid) {
            councilDetails.name = council.councilLong
          }
        })
        return (
          <div className='CurrentCouncilSection'>
            <Tooltip
                placement="top"
                title="Please contact the council you are currently registered at asking to have the council updated as your current council."
            >
                <span class='CurrentCouncilHeader'> Current Council </span>
                <span> {councilDetails.name}</span> 
            </Tooltip>
          </div>
        )
      }   
    }
  }

  phone = () => {
    if (!this.props.alumniprofileinfo) {
      return <Skeleton width={200} />
    } else if(Array.isArray(this.props.alumniprofileinfo.phones) && this.props.alumniprofileinfo.phones.length != 0){
      let personphone = this.props.alumniprofileinfo.phones.filter(data => ((typeof(data.isPrimary) === "string" && data.isPrimary.toLowerCase() === "true") || typeof(data.isPrimary) === "boolean" && data.isPrimary))[0];
      let phoneNumber;
      if (personphone) {
        const countryCode = personphone.countryCode ? personphone.countryCode.replace(/^0+/, '') : "--";
        if(personphone.country && personphone.country === "USA") {
          const areaCode = personphone.areaCode ? personphone.areaCode : '';
          const prefix = personphone.prefix ? personphone.prefix : '';
          const lineNumber = personphone.lineNumber ? personphone.lineNumber : '';
          phoneNumber = `${countryCode} ${areaCode} ${prefix} ${lineNumber}`
        } else {
          let areaCode = personphone.areaCode ? personphone.areaCode : ''
          let prefix = personphone.prefix ? personphone.prefix : ""
          let lineNumber = personphone.lineNumber ? personphone.lineNumber : ""
          const truncatedphoneNumber = personphone.fullPhoneNumber ? personphone.fullPhoneNumber.substr(personphone.fullPhoneNumber.indexOf(' ')+1) : `${areaCode} ${prefix} ${lineNumber}`;
          const trimmedNumber = truncatedphoneNumber.trim().replace(/^0+/, '');
          phoneNumber = `${countryCode} ${trimmedNumber}`
        }
         
        return (<span> <i class='fa fa-phone'></i> {phoneNumber ? ` +${phoneNumber}` : ""} </span>)
      }
      return (<span> <i class='fa fa-phone'></i> N/A </span>) //<Skeleton width={200} />
    }
    else{
      return (<span> <i class='fa fa-phone'></i> {this.props.alumniprofileinfo.phones} </span>)
    }
  }

  name = () => {
    if (this.props.loading) {
      return <Skeleton width={200} />
    }
    else if (!this.props.alumniprofileinfo || this.props.loading) {
      return <Skeleton width={200} />
    }
    else if (this.props.alumniprofileinfo) {
      console.log("Environment Variables ", process.env);

      console.log('Environment Name', REACT_APP_ENVIRONMENT);
      let firstName = '';
      let middleName = '';
      let lastName = '';
      let nameSuffix = '';
      let profileInfo = this.props.alumniprofileinfo;
      if (profileInfo) {
        if (this.props.isadmin && profileInfo.profile) {
          firstName = profileInfo.profile.firstName || '';
          middleName = profileInfo.profile.middleName || '';
          lastName = profileInfo.profile.lastName || '';
          nameSuffix = profileInfo.profile.nameSuffix || '';
        } else {
          firstName = profileInfo.firstName || '';
          middleName = profileInfo.middleName || '';
          lastName = profileInfo.lastName || '';
          nameSuffix = profileInfo.nameSuffix || '';
        }
        const fullName = `${firstName} ${middleName} ${lastName} ${nameSuffix}`.trim();
        return fullName || (profileInfo && profileInfo.profile && profileInfo.profile.fullName) || '';
      }
    }
    else {
      return <Skeleton width={200} />
    }  
  }
  checkIsDeceased = () => {
    if (!this.props.alumniprofileinfo) {
      return <Skeleton width={100} />
    }   
    else{
      const { profile } = this.props.alumniprofileinfo || {};
      const { isDeceased } = profile || this.props.alumniprofileinfo;

      return isDeceased ? " - Deceased" : '';
    }
  }

  renderRanks = () => {
    if (this.props.ranks_loading)
      return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Ranks..." />
    if (this.props.ranks && this.props.allranks) {
      let ranks = this.props.ranks
      let allranks = this.props.allranks.ranks
      if (ranks.length == 0)
        return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      else {
        return ranks.map((k, index) => {
          return allranks.map((j, index) => {
            const earnedDate = GetRanksDate(k, this.props.eagleinfo);
            if (k.rankId == j.id) {
              return (<Row type='flex' justify='flex-start' align='middle'>
                <Col span={6} className='text-center'>
                  <img src={j.imageUrl100} className='rank-img' />
                </Col>
                <Col span={18}>
                  <Row type='flex' justify='flex-start' align='middle'>
                    <Col span={24}>
                      <span className='rank-name'>{k.rankName}</span>
                    </Col>
                    <Col span={24}>
                      <span className='rank-date'>{earnedDate ? earnedDate : '-'}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>)
            }
          })
        })
      }
    }
  }

  // rendermycouncils = () => {
  //   if (this.props.councils_adding) {
  //     return <Spin indicator={LoadingIcon} className="m-t-20 text-center width-100" tip="Adding Council Affliations..." />
  //   }
  //   else if (this.props.councils_deleting) {
  //     return <Spin indicator={LoadingIcon} className="m-t-20 text-center width-100" tip="Deleting Council Affliations..." />
  //   }
  //   else if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="m-t-20 text-center width-100" tip="Loading Council Affliations..." />
  //   }
  //   else if (this.props.profileinfo && this.props.councils && this.props.eagleinfo) {
  //     let eagleCouncil = '';
  //     if (this.props.eagleinfo.eagleCouncilName) {
  //       eagleCouncil = this.props.eagleinfo.eagleCouncilName.replace(/ *\([^)]*\) */g, "")
  //     }
  //     let councilresources = this.props.profileinfo.extendedProfile
  //     let count = councilresources.filter(function (obj) {
  //       return obj.attributeId == '21';
  //     });
  //     if (count == 0 && eagleCouncil == '') {
  //       return <Row className='width-100' type='flex' align='middle' justify='center'>
  //         <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //           <Col xs={24} sm={24} md={6} lg={6} xl={6}>
  //             <img className='memb-img' src="../nocouncil.png" />
  //           </Col>
  //           <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
  //             <Row type='flex' align='bottom' justify='center'>
  //               <span className='memb-exp'>No Council Found!</span>
  //             </Row>
  //           </Col>
  //         </Col>
  //       </Row>
  //     }
  //     return councilresources.map((k, index) => {
  //       if (eagleCouncil == k.attributeVal) {
  //         return false
  //       }
  //       if (k.attributeId == '21') {
  //         return (
  //           <div className='scoutingaffiliations'>
  //             <Row type='flex' className='awardsection width-100' justify='flex-start' align='middle'>
  //               <Row type='flex' className='width-100' justify='flex-start' align='middle'>
  //                 <Col span={22}>
  //                   <span className='m-l-20 award-name'>{k.attributeVal}</span>
  //                 </Col>
  //               </Row>
  //             </Row>
  //           </div>)
  //       }
  //     })
  //   }
  // }

  // rendermyeaglecouncil = () => {
  //   if (this.props.eagleinfo) {
  //     if (Object.keys(this.props.eagleinfo).length !== 0) {
  //       if (this.props.eagleinfo.eagleCouncilName != '') {
  //         let eagleCouncil = ''
  //         if (this.props.eagleinfo.eagleCouncilName) {
  //           eagleCouncil = this.props.eagleinfo.eagleCouncilName.replace(/ *\([^)]*\) */g, "")
  //         }
  //         return (
  //           <div className='scoutingaffiliations'>
  //             <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
  //               <Col span={20}>
  //                 <Row type='flex' justify='flex-start' align='middle'>
  //                   <Col span={24}>
  //                     <span className='m-l-20 award-name'>{eagleCouncil}</span>
  //                   </Col>
  //                 </Row>
  //               </Col>
  //               <Col span={2}>
  //                 <img className="eagle-logo" src='./eagle-scout.png' />
  //               </Col>
  //             </Row>
  //           </div>)
  //       }
  //     }
  //   }
  // }

  // rendermyscoutings = () => {
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Scouting Affliations..." />
  //   }
  //   if (this.props.profileinfo && this.props.scoutings && this.props.nesa_reg) {
  //     let scoutingresources = this.props.profileinfo.extendedProfile
  //     let notfound = scoutingresources.some(attribute => attribute['attributeId'] == '20')
  //     if (!notfound && this.props.nesa_reg.length == 0) {
  //       return <Empty className='width-100 text-center' description={
  //         <span>
  //           No Records Found!
  //         </span>
  //       } image={Empty.PRESENTED_IMAGE_DEFAULT} />
  //     }
  //     return scoutingresources.map((k, index) => {
  //       if (k.attributeId == '20') {
  //         return this.props.scoutings.map((j, index) => {
  //           if (k.attributeVal == j.name) {
  //             let imgurl = (j.logo == "" || j.logo == null) ? "../nonationalassociation.png" : j.logo
  //             return (
  //               <div className='scoutingaffiliations'>
  //                 {/* <Row className='affinityIcons' type='flex' align='bottom' justify='end'>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Love">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/love.png")} onMouseOver={e => (e.currentTarget.src = "/h-love.png")} className='pointer' src='/love.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Volunteer">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/volunteer.png")} onMouseOver={e => (e.currentTarget.src = "/h-volunteer.png")} className='pointer' src='/volunteer.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Camp">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/camp.png")} onMouseOver={e => (e.currentTarget.src = "/h-camp.png")} className='pointer' src='/camp.png' />
  //                 </Tooltip>
  //               </Col>
  //               <Col className='icon'>
  //                 <Tooltip placement="top" title="Donate">
  //                   <img onMouseLeave={e => (e.currentTarget.src = "/dollar.png")} onMouseOver={e => (e.currentTarget.src = "/h-dollar.png")} className='pointer' src='/dollar.png' />
  //                 </Tooltip>
  //               </Col>
  //             </Row>
  //             */}
  //                 <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
  //                   <Col span={6} className='text-center'>
  //                     <img src={imgurl} className='award-img' />
  //                   </Col>
  //                   <Col span={18}>
  //                     <Row type='flex' justify='flex-start' align='middle'>
  //                     {j.name === 'National Eagle Scout Association' && this.state.hasCurrentNESAmembership ? 
  //                           <Col span={24} onClick={this.showEagleInformation}>
  //                             <Row type='flex' justify='flex-start' align='middle'>
  //                               <Col span={24}>
  //                                 <span className='award-name'>{this.state.ActiveMembership && Number(this.state.ActiveMembership[0].programId) == 30 ? 'NESA 5Year' : 'NESA Lifetime'}</span>
  //                               </Col>
  //                               <Col span={24}>
  //                                 <span className='m-l-0 award-date'>expires {this.state.ActiveMembership && this.state.ActiveMembership[0].expireDate ? moment(this.state.ActiveMembership[0].expireDate).format('MM/DD/YYYY') : "-"}</span>
  //                               </Col>
  //                             </Row>
  //                           </Col>
  //                         :
  //                         <Col span={24}>
  //                           <span className='award-name'>{j.name}</span>
  //                         </Col>
  //                       }
  //                       {/* <Col span={24}>
  //                 <span className='award-date'>{k.dateEarned}</span>
  //               </Col> */}
  //                     </Row>
  //                   </Col>
  //                 </Row>
  //               </div>)
  //           }
  //         })
  //       }
  //     })
  //   }
  // }

  // renderAwards = () => {
  //   if (this.props.awardsloading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Awards..." />
  //   }
  //   if (this.props.awards) {
  //     let award = this.props.awards.awards
  //     var distintic_awards = award.reduceRight(function (r, a) {
  //       r.some(function (b) { return a.name === b.name; }) || r.push(a);
  //       return r;
  //     }, []);
  //     if (distintic_awards.length == 0) {
  //       return <Row className='width-100' type='flex' align='middle' justify='center'>
  //         <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //           <Col xs={24} sm={24} md={6} lg={6} xl={6}>
  //             <img className='memb-img' src="../noawards.png" />
  //           </Col>
  //           <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
  //             <Row type='flex' align='bottom' justify='center'>
  //               <span className='memb-exp'>No Awards Found!</span>
  //             </Row>
  //           </Col>
  //         </Col>
  //       </Row>
  //     } else {
  //       return distintic_awards.map((k, index) => {
  //         let imgurl = (k.imageFilePath == "" || k.imageFilePath == null) ? "../noawards.png" : k.imageFilePath
  //         return (
  //           <Row type='flex' className='awardcontainer' justify='flex-start' align='middle'>
  //             <Col span={6} className='text-center'>
  //               <img src={imgurl} className='award-img' />
  //             </Col>
  //             <Col span={18}>
  //               <Row type='flex' justify='flex-start' align='middle'>
  //                 <Col span={24}>
  //                   <span className='award-name'>{k.name}</span>
  //                 </Col>
  //                 {/* <Col span={24}>
  //                 <span className='award-date'>{k.dateEarned}</span>
  //               </Col> */}
  //               </Row>
  //             </Col>
  //           </Row>)
  //       })
  //     }
  //   }
  // }

  // renderMyLocalAwardsSection = () => {
  //   if (this.props.localAwards_Loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Local Awards..." />
  //   }
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Local Awards..." />
  //   }

  //   if(this.props.profileinfo && this.props.localAwards) {
  //      let awardResources = this.props.profileinfo.extendedProfile;
  //      let notfound = awardResources.some(attribute => attribute['attributeId'] == '24');

  //      if (!notfound) {
  //       return <Row className='width-100' type='flex' align='middle' justify='center'>
  //         <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //           <Col xs={24} sm={24} md={6} lg={6} xl={6}>
  //             <img className='memb-img' src="../noawards.png" />
  //           </Col>
  //           <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
  //             <Row type='flex' align='bottom' justify='center'>
  //               <span className='memb-exp'>No Awards Found!</span>
  //             </Row>
  //           </Col>
  //         </Col>
  //       </Row>
  //     }

  //      this.props.localAwards.sort((a,b) => {
  //       return a.name.localeCompare(b.name);
  //     })

  //     return awardResources.map((k, index) => {
  //       if (k.attributeId == '24') {
  //         return this.props.localAwards.map((j, index) => {
  //           if (k.attributeVal == j.name) {
  //             return (
  //               <div className='affinitiessection'>
  //                 <Row type='flex' justify='flex-start' align='middle'>
  //                   <Col className='awardscolumn'>
  //                     <Row type='flex' justify='flex-start' align='middle'>
  //                       <Col span={24}>
  //                         <span className='m-l-20 award-name'>{j.name}</span>
  //                       </Col>
  //                     </Row>
  //                   </Col>
                    
  //                 </Row>
  //               </div>)
  //           }
  //         })
  //       }
  //     })
  //   }
  // }



  // renderMyAffinityGroups = () => {
  //   if (this.props.affinities_loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Affinity Groups..." />
  //   }
  //   if (this.props.affinities_loading) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Deleting Affinity Group..." />
  //   }
  //   if (!this.props.profileinfo) {
  //     return <Spin indicator={LoadingIcon} className="loading-state text-center width-100" tip="Loading Affinity Groups..." />
  //   }

  //   if(this.props.profileinfo && this.props.affinities) {
  //     let affinityResources = this.props.profileinfo.extendedProfile;
  //     let notfound = affinityResources.some(attribute => attribute['attributeId'] == '22')
  //     if (!notfound) {
  //       return <Row className='width-100' type='flex' align='middle' justify='center'>
  //         <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //           <Col xs={24} sm={24} md={6} lg={6} xl={6}>
  //             <img className='memb-img' src="../noawards.png" />
  //           </Col>
  //           <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
  //             <Row type='flex' align='bottom' justify='center'>
  //               <span className='memb-exp'>No Affinities Found!</span>
  //             </Row>
  //           </Col>
  //         </Col>
  //       </Row>
  //     }

  //   this.props.affinities.sort((a,b) => {
  //     return a.name.localeCompare(b.name);
  //   })

  //   return affinityResources.map((k, index) => {
  //     if (k.attributeId == '22') {
  //       return this.props.affinities.map((j, index) => {
  //         if (k.attributeVal == j.name) {
  //           let imgurl = (j.logo == "" || j.logo == null) ? "../nonationalassociation.png" : j.logo
  //           return (
  //             <div className='affinitygroups'>
  //               <Row type='flex' className='awardsection' justify='flex-start' align='middle'>
  //                 <Col span={9} className='text-center'>
  //                   <img src={imgurl} className='award-img' />
  //                 </Col>
  //                 <Col span={13}>
  //                   <Row type='flex' justify='flex-start' align='middle'>
  //                     <Col span={24}>
  //                       <span className='award-name'>{j.name}</span>
  //                     </Col>
  //                   </Row>
  //                 </Col>
  //               </Row>
  //             </div>)
  //         }
  //       })
  //     }
  //   })

  //   }
  // }

  renderProfileImg = () => {
    let self = this
    if (!this.props.profileinfo || this.props.pic_updating) {
      return <Spin indicator={LoadingIcon} style={{ width: '99px' }} className='ad-profile-img flex-center' />
    }
    else {
      let profile = this.props.profileinfo
      let imgurl = '';
      imgurl = profile && profile.profile && profile.profile.pictureUrl ? profile.profile.pictureUrl : profile.pictureUrl ? profile.pictureUrl : '';
      if (imgurl == "" || imgurl == null) imgurl = "../profileimage.png"
      return <img src={imgurl} className='ad-profile-img' />
    }
  }

  publications = () => {
    if (!this.props.publications) {
      return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Publications..." />
    }
    else {
      let publicationjson = this.props.publications
      let self = this
      return publicationjson.map((k, index) => {
        return (
          <div key={index}>
            <Row type='flex' justify='flex-start' align='middle'>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} className='publication-content'>
                <div data-configid={(k.response.rsp._content.result._content.length != 0) ? (k.response.rsp._content.result._content[0].documentEmbed.dataConfigId) : ""} style={{ width: '100%', height: '100%' }} class="issuuembed"></div>
              </Col>
              <Col xs={24} sm={24} md={13} lg={13} xl={13} className='publication-content'>
                <Row type='flex' justify='flex-start' align='middle'>
                  <Col span={24}>
                    <span className='mag-name'>{k.title}</span>
                  </Col>
                  <Col span={24}>
                    <span className='mag-date'>{(k.response.rsp._content.result._content.length != 0) ? moment(k.response.rsp._content.result._content[0].documentEmbed.created).format('MM/D/YYYY') : ""}</span>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr className='border-bottom' />
            {this.loadiFramscript()}
          </div>
        )
      })
    }
  }

  getSAFreg = () => {
    if (this.props.saf_reg && this.props.saflevels) {
      let safreg = this.props.saf_reg
      let saflevels = this.props.saflevels
      let Membership_ID = ''
      let Membership_Name = ''
      let expireDate = ''
      let ActiveMembership = false
      if (safreg.length != 0 && safreg != "error") {
        safreg.map((k, index) => {
          if (k.isActive === true) {
            ActiveMembership = true
            Membership_ID = k.programId
            expireDate = k.expireDate
            saflevels.map((j, index) => {
              if (parseInt(j.id) == Membership_ID) {
                Membership_Name = j.name
              }
            })
          }
        })
        if (ActiveMembership) {
          return <Row className='width-100' type='flex' align='middle' justify='center'>
            <Col className='center align-center' xs={24} sm={24} md={24} lg={24} xl={24}>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img className='memb-img' src="../saf_logo.jpg" />
              </Col>
              <Col xs={24} sm={24} md={18} lg={18} xl={18} >
                <span className='memb-name'>{Membership_Name.replace(/-/g, " ")}</span> <br />
                <span className='memb-exp'>Expires {expireDate ? moment(expireDate).format('MM/DD/YYYY') : "-"}</span>
              </Col>
            </Col>
          </Row>
        } else {
          return <Row className='width-100' type='flex' align='middle' justify='center'>
            <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img className='memb-img' src="../no_saf.jpg" />
              </Col>
              <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
                <Row type='flex' align='bottom' justify='center'>
                  <span className='memb-exp'>No SAF Records Found!</span>
                </Row>
              </Col>
            </Col>
          </Row>
        }
      } else {
        return <Row className='width-100' type='flex' align='middle' justify='center'>
          <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <img className='memb-img' src="../no_saf.jpg" />
            </Col>
            <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
              <Row type='flex' align='bottom' justify='center'>
                <span className='memb-exp'>No SAF Records Found!</span>
              </Row>
            </Col>
          </Col>
        </Row>
      }
    } else {
      return <Row className='width-100' type='flex' align='middle' justify='center'>
        <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
          <Spin indicator={antIcon} tip='loading SAF Records!' />
        </Col>
      </Row>
    }
  }

  // getNESAreg = () => {
  //   if (this.props.nesa_reg && this.props.nesa_levels) {
  //     let nesareg = this.props.nesa_reg
  //     let nesalevels = this.props.nesa_levels
  //     let Membership_ID = ''
  //     let Membership_Name = ''
  //     let expireDate = ''
  //     let ActiveMembership = false
  //     if (nesareg.length != 0 && nesareg != "error") {
  //       nesareg.map((k, index) => {
  //         if (k.isActive === true) {
  //           ActiveMembership = true
  //           Membership_ID = k.programId
  //           expireDate = k.expireDate
  //           nesalevels.map((j, index) => {
  //             if (parseInt(j.id) === Membership_ID) {
  //               Membership_Name = j.name
  //             }
  //           })
  //         }
  //       })
  //       if (ActiveMembership) {
  //         return <Row type='flex' className='awardsection NesaAwardSection' justify='flex-start' onClick={this.showEagleInformation} align='middle'>
  //           <Col span={6} className='text-center'>
  //             <img src="../NESA.png" className='award-img' />
  //           </Col>
  //           <Col span={18}>
  //             <Row type='flex' justify='flex-start' align='middle'>
  //               <Col span={24}>
  //                 <span className='award-name'>{Membership_Name.replace(/-/g, " ")}</span>
  //               </Col>
  //               <Col span={24}>
  //                 <span className='m-l-0 award-date'>expires {expireDate ? moment(expireDate).format('MM/DD/YYYY') : "-"}</span>
  //               </Col>
  //             </Row>
  //           </Col>
  //         </Row>

  //         // return <Row type='flex' align='middle' justify='center'>
  //         //   <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //         //     <Col xs={12} sm={12} md={6} lg={6} xl={6}>
  //         //       <img className='memb-img' src="../NESA.png" />
  //         //     </Col>
  //         //     <Col xs={12} sm={12} md={18} lg={18} xl={18} >
  //         //       <Row type='flex' align='middle' justify='center'>
  //         //         <span className='memb-name'>{Membership_Name.replace(/-/g, " ")}</span> <br />
  //         //         <span className='memb-exp'>Expires {expireDate ? moment(expireDate).format('MM/DD/YYYY') : "-"}</span>
  //         //       </Row>
  //         //     </Col>
  //         //   </Col>
  //         // </Row>
  //       } else {
  //         // return <Row className='width-100' type='flex' align='middle' justify='center'>
  //         //   <Col className='center flex-baseline' xs={24} sm={24} md={24} lg={24} xl={24}>
  //         //     <Col xs={12} sm={12} md={6} lg={6} xl={6}>
  //         //       <img className='memb-img' src="../no_nesa.png" />
  //         //     </Col>
  //         //     <Col className='margin-top-10' xs={12} sm={12} md={18} lg={18} xl={18} >
  //         //       <Row type='flex' align='bottom' justify='center'>
  //         //         <span className='memb-exp'>No NESA Records Found!</span>
  //         //       </Row>
  //         //     </Col>
  //         //   </Col>
  //         // </Row>
  //       }

  //     } else {
  //       // return <Row className='width-100' type='flex' align='middle' justify='center'>
  //       //   <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //       //     <Col xs={24} sm={24} md={6} lg={6} xl={6}>
  //       //       <img className='memb-img' src="../no_nesa.png" />
  //       //     </Col>
  //       //     <Col className='margin-top-10' xs={24} sm={24} md={18} lg={18} xl={18} >
  //       //       <Row type='flex' align='bottom' justify='center'>
  //       //         <span className='memb-exp'>No NESA Records Found!</span>
  //       //       </Row>
  //       //     </Col>
  //       //   </Col>
  //       // </Row>
  //     }
  //   } else {
  //     // return <Row className='width-100' type='flex' align='middle' justify='center'>
  //     //   <Col className='center' xs={24} sm={24} md={24} lg={24} xl={24}>
  //     //     <Spin indicator={antIcon} tip='loading NESA Records!' />
  //     //   </Col>
  //     // </Row>
  //   }
  // }

  showEagleInformation = () => {
    this.setState({
      EagleInfoVisible: true,
    })
  }

  closeEagleInfoModal = () => {
    this.setState({
      EagleInfoVisible: false,
    })
  }

  renderRenewMembershipButton = () => {
    let expireDate = '';

    if(this.props.nesa_reg && this.props.nesa_reg.length !== 0){
        this.props.nesa_reg.map((k, index) => {
          if(k.isActive === true){
            expireDate = k.expireDate
          }
        })
    }
    
    const currentDate = new Date();
    const eagleExpireDate = new Date(expireDate);
    const expireLimit = 6;

    const monthDifference = Math.max(
      (eagleExpireDate.getFullYear() - currentDate.getFullYear()) * 12 + eagleExpireDate.getMonth() - currentDate.getMonth(), 0
    )

    if(monthDifference <= expireLimit){
      return (
        <div className="RenewMembershipSection">
          <Button key="back" className="RenewMembershipHandler" onClick={this.RenewMembershipHandler}>
              Renew Membership
          </Button>
        </div>
      )
    }else{
      return;
    }

  }

  RenewMembershipHandler = () => {
    history.push('/purchase-membership')
  }

  renderEagleMembershipInfo = () => {
    let nesareg = this.props.nesa_reg ? this.props.nesa_reg : []
    let nesalevels = this.props.nesa_levels ? this.props.nesa_levels : [];

    let membershipType = '';
    let membershipId = '';
    let expiryDate = '';

    if (nesareg.length != 0 && nesalevels.length !=0 && nesareg != "error"){
      nesareg.map((k, index) => {
        if(k.isActive === true){
          membershipId = k.programId
          expiryDate = k.expireDate

          nesalevels.map((j, index) => {
            if(parseInt(j.id) == membershipId){
              membershipType = j.name;
            }
          })
        }
      })
    }

    return (
      <div className="EagleMembershipInfo">
        <span className="MembershipTypeInfo">Membership Type: </span>
        <span className="MembershipTypeInfoValue">{membershipType}</span>
        
        <span className="MembershipExpirationDate">Expiration Date: </span>
            <span className="MembershipExpirationDateValue">{
              expiryDate ? moment(expiryDate).format('MM/DD/YYYY') : '---'}
            </span>
      </div>
    )
}

  render() {
    return (
      <div>
        <LayoutHeader />
        <AlumniNavigation />
        <div className='dashboard-layout centered'>
          <Row type="flex" justify="center" align="middle">
            <Col xs={24} sm={24} md={24} lg={24} xl={14}>
              <div className='widget'>
                <div className='widget-layout'>
                  <Row type='flex'>
                    <Col xs={24} sm={24} md={11} lg={11} xl={11}>
                      <div className='ad-bg-banner'>
                        <Row type='flex' justify='flex-start' align='middle'>
                          <Col span={24} className='text-left'>
                            <div>
                              <span className='text' style={{ display: 'inline' }}>{this.name()}</span>
                              <span className='breadcrums'>{this.checkIsDeceased()}</span>
                            </div>
                          </Col>
                        </Row>
                        <Row type='flex' justify='center' align='center'>
                          <Col span={24} className='flex-center'>
                            <div className='pic-container'>
                              {this.renderProfileImg()}
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <div className='text-right'> {this.rendereagleflag()} </div>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={13} lg={13} xl={13}>
                      <Row type='flex' className='ad-profile-des' justify='center' align='center'>
                        <Col span={24} className='text-left'>
                          {this.address()}
                        </Col>
                        <Col span={24} className='text-left  margin-top-5'>
                          {this.email()}
                        </Col>
                        <Col span={24} className='text-left  margin-top-5'>
                          {this.phone()}
                        </Col>
                        <Col span={24} className='text-left  margin-top-5'>
                          {this.currentCouncil()}
                        </Col>
                        {this.props.profileinfo &&
                          <Col span={24}>
                            <Divider />
                            {/* <Col span={12} className='text-left'>
                              <Dropdown overlay={menu} trigger={['click']}>
                                <a className="viewicon addmembeship-link ant-dropdown-link" onClick={e => e.preventDefault()}>
                                  <i class="fa fa-plus-circle primary-color " aria-hidden="true"></i> Add Membership <DownOutlined />
                                </a>
                              </Dropdown>
                            </Col>
                            <Col span={12} className='text-right'>
                              <span onClick={() => history.push('/my-profile')} className='viewicon pointer'><i class="fa fa-pencil" aria-hidden="true"></i> Edit Profile</span>
                            </Col> */}
                            <div className="AddMembership">
                              To View, add, or update your Scouting Affiliations Including accessing
                              NESA membership, simply <span onClick={() => {
                                if(this.state.panelView === 'alumniTabView' && this.props.isadmin === true){
                                  localStorage.setItem("panelView", JSON.stringify("adminTabView"))
                                }
                                history.push('/my-profile')
                              }} className="EditAddMembership"> edit </span>
                              your profile and add an affiliation from the drop-down list.
                            </div>
                          </Col>
                        }
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            <MyAwardsComponent />

            <div className='hobbiesAndBusiness' style={{width: '100%'}}>

              <HobbiesAndBusinessComponent eagleInfo={this.props.eagleinfo} /> 
              {/* Social Information */}
              <SocialInfo />
            </div>
            {/* <Col xs={24} sm={24} md={24} lg={24} xl={10}>
              <div className='container max-height-200 min-height-200'>
                <div className='widget-content'>
                  <Row type="flex" justify="space-between">
                    <div className='widget-header-text'>
                      My Communication Preferences
                          </div>
                    <div className='widget-header-tool'>
                      {/* <label className='pointer' onClick={this.showModal} > Add New </label> 
                    </div>
                  </Row>
                  <MyCommunicationPreference />
                </div>
              </div>
            </Col> */}
          </Row>



          {/* {
          this.props.eagleinfo ? 

          <Modal
          centered
          className='EagleScoutInformationModal'
          title="Eagle Information"
          visible={this.state.EagleInfoVisible}
          closable={false}
          footer={[
              <div className="EagleInfoFooterActions">
                  {this.renderRenewMembershipButton()}
                  <Button key="back" className="CloseEagleInformation" onClick={this.closeEagleInfoModal}>
                      OK
                  </Button>
              </div>
          ]}
          >
            <Row gutter={48} className="eagle-info-container">
              <Row className="eaglescout-info-panel">
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Member ID: </label>
                      <label className='membership-field-value'>{this.props.eagleinfo.memberId ? this.props.eagleinfo.memberId : '- -'}</label>
                  </Col>
                  <Col span={14}>
                      <label className='membership-field-label'> First Name:  </label>
                      <label className='membership-field-value'>{this.props.eagleinfo.firstName ? this.props.eagleinfo.firstName : '- -'}</label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Middle Name:  </label>
                      <label className='membership-field-value'>{this.props.eagleinfo.middleName ? this.props.eagleinfo.middleName : '- -'}</label>
                  </Col>
                  <Col span={14}>
                      <label className='membership-field-label'>  Last Name:  </label>
                      <label className='membership-field-value'>{this.props.eagleinfo.lastName ? this.props.eagleinfo.lastName : '- -'}</label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Date of Birth:  </label>
                      <label className='membership-field-value'>{
                        this.props.eagleinfo.dateOfBirth ? moment(this.props.eagleinfo.dateOfBirth).format('MM/DD/YYYY') : '---'
                      }</label>
                  </Col>
                  <label className='membership-field-label'>  Board Review Date:  </label>
                  <label className='membership-field-value'>
                    {
                      this.props.eagleinfo.eagleBoardReviewDate ? moment(this.props.eagleinfo.eagleBoardReviewDate).format('MM/DD/YYYY') : '---'
                    }
                  </label>
              </Row>

              <Row type='flex' align='middle'>
                  <Col span={10}>
                    <label className='membership-field-label'>  Eagle Unit Number:  </label>
                    <label className='membership-field-value'>
                      {this.props.eagleinfo.eagleUnitNumber ? this.props.eagleinfo.eagleUnitNumber : '---'}
                    </label>
                  </Col>
                  <Col span={14}>
                  <label className='membership-field-label'>  Eagle Scout City:  </label>
                  <label className='membership-field-value'>
                    {this.props.eagleinfo.eagleUnitCity ? this.props.eagleinfo.eagleUnitCity : '---'}
                  </label>
                  </Col>
              </Row>
              <Row type='flex' align='middle'>
                  <Col span={10}>
                      <label className='membership-field-label'>  Eagle Scout State:  </label>
                      <label className='membership-field-value'>{this.props.eagleinfo.eagleUnitState ? this.props.eagleinfo.eagleUnitState : '---'}</label>
                  </Col>
                  <Col span={14}>
                      
                  </Col>
              </Row>
              </Row>
            </Row>

            <div className="MembershipInfoHeader">
                NESA MEMBERSHIP INFORMATION
            </div>
            <div className="MembershipInfoHeaderPath"></div>

            {this.renderEagleMembershipInfo()}

          </Modal> : ""
      } */}


          {/* <Row type="flex" justify="center" align="middle">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className='widget'>
                <div className='widget-layout min-height-300'>
                  <div className='widget-header'>
                    <span className='title'> Upcoming Alumni Events </span>
                    <span className='setting pointer' onClick={() => history.push('/events')}> VIEW ALL </span>
                  </div>
                  <Row type='flex' justify='flex-start' align='middle'>
                    {this.props.events_loading && <Col span={24} > <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Events..." /> </Col>}
                    {this.props.events && this.props.events.events.map(function (eventdet, i) {
                      if (i > 1)
                        return false
                      else
                        return <Col xs={24} sm={24} md={12} lg={12} xl={12} key={i} className='text-left'>
                          <div className='widget'>
                            <div className='widget-layout min-height-200 padding-15'>
                              <Col span={24} className='text-left'>
                                <div className='ad-event-name' dangerouslySetInnerHTML={{ __html: eventdet.title }} />
                              </Col>
                              <Col span={24} className='text-left'>
                                <span className='ad-event-date'> <i class="fa fa-calendar"></i> {eventdet.start_date} to {eventdet.end_date} </span>
                              </Col>
                              <Col span={24} className='text-left'>
                                <span className='ad-event-date'> <i class="fa fa-map-marker"></i> {eventdet.venue.length != 0 ? eventdet.venue.venue : "-"} </span>
                              </Col>
                              <Col span={24} className='text-justify margin-top-10'>
                                <Truncate lines={5} ellipsis={<span>... <a href='/events'>See More</a></span>}>
                                  <div className='ad-event-des' dangerouslySetInnerHTML={{ __html: eventdet.description }} />
                                </Truncate>

                              </Col>
                            </div>
                          </div>
                        </Col>
                    })
                    }
                  </Row>

                </div>
              </div>
            </Col>

          </Row> */}


          {/* <Row type="flex" justify="center" align="middle">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className='widget margin-bottom-20'>
                <div className='widget-layout min-height-300'>
                  <div className='widget-header'>
                    <span className='title'> Featured Scout Shop Item </span>
                    <span className='setting'> GO TO SHOP </span>
                  </div>

                  <div className='scout-shop-container'>
                    <Iframe src="https://retaildv.scoutshop.org/external/product" height="390" width="100%" />
                  </div>

                </div>
              </div>
            </Col>
          </Row> */}
        </div >
        <NESAFooter />
      </div >
    );
  }
}



function mapStateToProps(state) {
  return {
    profileinfo: state.profilereducer.profileinfo,
    publications: state.publicationreducer.publications,
    alumniprofileinfo: state.alumniinforeducer.profileinfo,
    events_loading: state.eventreducer.loading,
    events: state.eventreducer.events,
    ranks_loading: state.myranksreducer.loading,
    ranks: state.myranksreducer.ranks,
    allranks_loading: state.allranksreducer.loading,
    allranks: state.allranksreducer.ranks,
    saf_loading: state.safregistrationreducer.loading,
    saf_reg: state.safregistrationreducer.reg,
    nesa_loading: state.nesaregistrationreducer.loading,
    nesa_reg: state.nesaregistrationreducer.reg,
    nesa_levels_loading: state.nesalevelsreducer.loading,
    nesa_levels: state.nesalevelsreducer.levels,
    saflevels_loading: state.saflevelsreducer.loading,
    awardsloading: state.awardsreducer.loading,
    awards: state.awardsreducer.awards,
    affinities_loading: state.affinitiesreducer.loading,
    affinities: state.affinitiesreducer.affinities,
    saflevels: state.saflevelsreducer.levels,
    scoutings_loading: state.scoutingsreducer.loading,
    scoutings: state.scoutingsreducer.scoutings,
    councils: state.councilsreducer.councils,
    allstates: state.allstatesreducer.states,
    eagleinfo: state.eagleinforeducer.eagleinfo,
    isadmin: state.isadminreducer.isadmin,
    localAwards_Loading: state.localAwardsReducer.loading,
    localAwards: state.localAwardsReducer.localAwards,
    isspecialist: state.isadminreducer.isspecialist
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AlumniDashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard/AlumniDashboard.js